import { IsNotEmpty } from "class-validator";
import { DataValidationError } from "constants/DataValidationError";

export default class DeleteDriverShiftReq {
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  readonly driverShiftId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.driverShiftId = arg.driverShiftId;
  }
}
